'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _lodash = require('lodash');

var _FormGroup = require('./FormGroup');

var _FormGroup2 = _interopRequireDefault(_FormGroup);

var _utils = require('./utils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Text = function (_Component) {
  _inherits(Text, _Component);

  function Text() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Text);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Text.__proto__ || Object.getPrototypeOf(Text)).call.apply(_ref, [this].concat(args))), _this), _this.handleChange = function (event) {
      _this.props.onChange(event.target.value);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Text, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          text = _props.text,
          errors = _props.errors,
          className = _props.className;

      var inputProps = (0, _lodash.pick)(this.props, ['value', 'placeholder', 'name', 'type', 'disabled', 'required', 'readOnly']);
      return _react2.default.createElement(
        _FormGroup2.default,
        {
          className: 'Text-root ' + className,
          text: text,
          errors: errors
        },
        _react2.default.createElement('input', _extends({
          className: 'Text-input'
        }, inputProps, {
          text: text,
          onChange: this.handleChange
        }))
      );
    }
  }]);

  return Text;
}(_react.Component);

Text.propTypes = _extends({}, _utils.genericPropTypes, {
  text: _propTypes2.default.string.isRequired,
  placeholder: _propTypes2.default.string,
  readOnly: _propTypes2.default.bool,
  type: _propTypes2.default.oneOf(['text', 'password', 'email']).isRequired
});

Text.defaultProps = _extends({}, _utils.genericDefaultProps, {
  value: '',
  placeholder: 'Please enter your response',
  readOnly: false,
  type: 'text'
});

exports.default = Text;


//////////////////
// WEBPACK FOOTER
// ../frontend-component-library/build/Components/FormInputs/Text.js
// module id = 228
// module chunks = 0